<template>
    <div class="app-input-wrap">
        <input :type="type"
                class="app-input"
                :class="{'app-input--white': theme === 'white', 'app-input--error' : !this.isValid && this.activated}"
                :value="value"
                :placeholder="placeholder"
                @input="onInput"
        >
    </div>
</template>

<script>
export default {
  name: "Input",
  props: {
    placeholder: {
      type: String,
      required: false,
      default: "",
    },
    type: {
      type: String,
      required: false,
      default: "text",
    },
    value: {
      type: String,
      required: false,
      default: "",
    },
    pattern: {
      type: RegExp,
      required: true,
    },
    theme: {
      type: String,
      required: false,
      default: "",
    },
  },
  data() {
    return {
      activated: this.value != "",
    };
  },
  mounted() {
    this.$emit("changeStatus", this.isValid);
  },
  computed: {
    isValid() {
      return this.pattern.test(this.value);
    },
  },
  methods: {
    onInput(e) {
      this.activated = true;
      this.$emit("onUpdateValue", e.target.value);
    },
  },
  watch: {
    isValid() {
      this.$emit("changeStatus", this.isValid);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/settings.scss";

.app-input-wrap {
  margin: 30px auto;
}
.app-input {
  border-radius: 0;
  font-weight: normal;
  padding: 15px;
  background-color: $card-hover-color;
  color: $white-color;
  border: 1px solid $gray-color;
  width: 100%;
  max-width: 450px;
  text-align: center;
  font-size: 1.6rem;
}

.app-input--white {
  background-color: $white-color;
  color: $black-color;
  border: 1px solid $light-gray-color;
}
.app-input--error,
.app-input--error:focus {
  border: 1px solid $error-color !important;
}

.app-input:focus {
  box-shadow: none;
  border: 1px solid $gray-color;
  outline: none;
  outline-offset: 0;
}

.app-input::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: $white-color;
  text-align: center;
}
.app-input::-moz-placeholder {
  /* Firefox 19+ */
  color: $white-color;
  text-align: center;
}
.app-input:-ms-input-placeholder {
  /* IE 10+ */
  color: $white-color;
  text-align: center;
}
.app-input:-moz-placeholder {
  /* Firefox 18- */
  color: $white-color;
  text-align: center;
}

.app-input--white::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: $black-color;
}
.app-input--white::-moz-placeholder {
  /* Firefox 19+ */
  color: $black-color;
}
.app-input--white:-ms-input-placeholder {
  /* IE 10+ */
  color: $black-color;
}
.app-input--white:-moz-placeholder {
  /* Firefox 18- */
  color: $black-color;
}
</style>
